export default "__VITE_ASSET__C33VK0mF__"